import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Login from '../../views/login/index.vue';
import frameWork from '@/views/framework/index.vue';
//import frameWork from '../../views/frameWork/index.vue'
export const routes: RouteRecordRaw[] = [];

routes.push(
  {
    path: '/framework',
    component: frameWork,
    name: "架构",

  },
  {
    path: '/login',
    component: Login,
    name: "登录页面",
  },
  {
    path: '/panel',
    redirect: '/panel/index',
    meta: { title: '工作空间' },
    name: "工作空间",
    component: frameWork,
    children: [
      {
        path: '/panel',
        name: '工作台',
        component: () => import('../../views/panel/index.vue'),
        meta: { title: '工作台', requireAuth: true, affix: true, closable: false },
      }
    ]
  },
    {
    path: '/obtain',
    redirect: '/obtain/index',
    meta: { title: '如何获取' },
    name: "工作空间",
    component: frameWork,
    children: [
      {
        path: '/obtain',
        name: '如何获取',
        component: () => import('../../views/obtain/index.vue'),
        meta: { title: '如何获取', requireAuth: true, affix: true, closable: false },
      }
    ]
  },
  // {
  //   path: '/menu',
  //   redirect: '/menu/index',
  //   meta: { title: '菜单管理' },
  //   name: "菜单管理",
  //   component: frameWork,
  //   children: [
  //     {
  //       path: '/menu',
  //       name: '菜单',
  //       component: () => import('../../views/menu/index.vue'),
  //       meta: { title: '菜单', requireAuth: true, affix: true, closable: false },
  //     }
  //   ]
  // },
  // {
  //   path: '/user',
  //   meta: { title: '用户管理' },
  //   name: "用户管理",
  //   component: FrameWork,
  //   children: [
  //     {
  //       path: '/user',
  //       name: '用户',
  //       component: () => import('../../views/user/index.vue'),
  //       meta: { title: '用户' },
  //     }]
  // },
)
